module.exports = __webpack_public_path__ + "static/00018.f69b044d.jpg";